import { config } from "uniswap/src/config";
import { RPCType, UniverseChainId } from "uniswap/src/features/chains/types";
import { ONE_MINUTE_MS } from "utilities/src/time/time";
export const DEFAULT_NATIVE_ADDRESS_LEGACY = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";
export const DEFAULT_NATIVE_ADDRESS = "0x0000000000000000000000000000000000000000";
export const DEFAULT_RETRY_OPTIONS = { n: 10, minWait: 250, maxWait: 1e3 };
export const DEFAULT_MS_BEFORE_WARNING = ONE_MINUTE_MS * 10;
export function getQuicknodeChainId(chainId) {
  switch (chainId) {
    case UniverseChainId.Mainnet:
      return "";
    case UniverseChainId.ArbitrumOne:
      return "arbitrum-mainnet";
    case UniverseChainId.Avalanche:
      return "avalanche-mainnet";
    case UniverseChainId.Base:
      return "base-mainnet";
    case UniverseChainId.Blast:
      return "blast-mainnet";
    case UniverseChainId.Bnb:
      return "bsc";
    case UniverseChainId.Celo:
      return "celo-mainnet";
    case UniverseChainId.MonadTestnet:
      return "monad-testnet";
    case UniverseChainId.Optimism:
      return "optimism";
    case UniverseChainId.Polygon:
      return "matic";
    case UniverseChainId.Sepolia:
      return "ethereum-sepolia";
    case UniverseChainId.Unichain:
      return "unichain-mainnet";
    case UniverseChainId.UnichainSepolia:
      return "unichain-sepolia";
    case UniverseChainId.WorldChain:
      return "worldchain-mainnet";
    case UniverseChainId.Zksync:
      return "zksync-mainnet";
    case UniverseChainId.Zora:
      return "zora-mainnet";
    default:
      throw new Error(`Chain ${chainId} does not have a corresponding QuickNode chain ID`);
  }
}
export function getQuicknodeChainIdPathSuffix(chainId) {
  switch (chainId) {
    case UniverseChainId.Avalanche:
      return "/ext/bc/C/rpc";
    default:
      return "";
  }
}
export function getQuicknodeEndpointUrl(chainId) {
  const quicknodeChainId = getQuicknodeChainId(chainId);
  return `https://${config.quicknodeEndpointName}${quicknodeChainId ? `.${quicknodeChainId}` : ""}.quiknode.pro/${config.quicknodeEndpointToken}${getQuicknodeChainIdPathSuffix(chainId)}`;
}
export function getPlaywrightRpcUrls(url) {
  return {
    [RPCType.Public]: { http: [url] },
    [RPCType.Default]: { http: [url] },
    [RPCType.Fallback]: { http: [url] },
    [RPCType.Interface]: { http: [url] },
    [RPCType.Private]: { http: [url] },
    [RPCType.PublicAlt]: { http: [url] }
  };
}
